const UserProfile = () => {
    return <h3>UserProfile</h3>
}

export default UserProfile;